/* eslint-disable no-return-assign */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import * as actions from '../actions';

function ViewUpdateBusinessActivityItem({
  id,
  data,
  feeCalculationFormData,
  setFeeCalculationFormData,
}) {
  const [formUpdate, setFormUpdate] = useState({
    ...data,
  });

  useEffect(() => {
    if (!_.isEmpty(feeCalculationFormData)) {
      setFeeCalculationFormData({
        ...feeCalculationFormData,
        calculation_details:
          feeCalculationFormData.calculation_details.map((item, yearId) => {
            return yearId === id ? { ...item, ...formUpdate } : item;
          }) || '',
      });
    }
  }, [formUpdate]);

  const onChange = e => {
    setFormUpdate({
      ...formUpdate,
      [e.target.name]: e.target.value,
    });
  };

  const quarter = period => {
    if (period === 1) return '1 QTR';
    if (period === 2) return '2 QTR';
    if (period === 3) return '3 QTR';
    if (period === 4) return '4 QTR';
    return '';
  };

  const validateForm = useFormValidator(formUpdate, {
    amount: 'required|number',
  });

  useEffect(() => {
    validateForm.validate();
  }, [Object.keys(formUpdate).join(','), Object.values(formUpdate).join(',')]);

  return (
    <div className="row p-2">
      <div className="col-2">
        <div className="form-group mb-0">
          <label className="form-label mb-0" />
          <input
            className="form-control"
            name="code"
            onChange={onChange}
            value={_.get(formUpdate, 'code')}
            disabled
          />
        </div>
      </div>
      <div className="col-4">
        <div className="form-group mb-0">
          <label className="form-label mb-0" />
          <input
            className="form-control"
            name="description"
            onChange={onChange}
            value={_.get(formUpdate, 'description')}
            disabled
          />
        </div>
      </div>
      <div className="col-1">
        <div className="form-group mb-0">
          <label className="form-label mb-0" />
          <input
            className="form-control"
            name="year"
            onChange={onChange}
            value={_.get(formUpdate, 'year')}
            disabled
          />
        </div>
      </div>
      <div className="col-2">
        <div className="form-group mb-0">
          <label className="form-label mb-0" />
          <input
            className="form-control"
            onChange={onChange}
            value={`${_.get(formUpdate, 'qtr_from') || ''}-${quarter(
              _.get(formUpdate, 'qtr_to')
            ) || ''}`}
            disabled
          />
        </div>
      </div>
      <div className="col-3">
        <div className="form-group mb-0">
          <label className="form-label mb-0">
            {validateForm.renderMessage('amount')}
          </label>
          <NumberFormat
            name="amount"
            id="amount"
            placeholder="0"
            className="form-control"
            onValueChange={values => {
              const { value } = values;
              setFormUpdate({
                ...formUpdate,
                amount: value,
              });
            }}
            /* eslint-disable */
            isNumericString={true}
            thousandSeparator={true}
            allowNegative={true}
            allowLeadingZeros={true}
            displayType="input"
            prefix=""
            value={`${_.get(formUpdate, 'amount', '')}` || ''}
          />
        </div>
      </div>
    </div>
  );
}

ViewUpdateBusinessActivityItem.propTypes = {
  id: PropTypes.number.isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  feeCalculationFormData: PropTypes.instanceOf(Object).isRequired,
  setFeeCalculationFormData: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewUpdateBusinessActivityItem);
